module.exports = __webpack_public_path__ + "img/awards_trophy2.9d97492e.png";